var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNoticeDefault = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "14px",
    viewBox: "0 0 12 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u6D88\u606F\u901A\u77E5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u6D88\\u606F\\u901A\\u77E5",
    transform: "translate(-0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5,5 L10,5 L10,5 L10,12 L5,12 L5,7.5 C5,6.11928813 6.11928813,5 7.5,5 Z",
    id: "\\u77E9\\u5F62",
    fillOpacity: 0.4,
    fill: "#52C41A"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u6D88\\u606F-(2)",
    fill: "#041B0F",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0841262,12.25 L0.584126236,12.25 C0.363693544,12.25 0.161770467,12.1254808 0.0624916208,11.9286058 C-0.0367872253,11.7317308 -0.0165949176,11.4961538 0.114655082,11.3194712 L1.42042431,9.55432692 L1.42042431,6.125 C1.42042431,3.71201923 3.40095316,1.75 5.83412624,1.75 C8.26729931,1.75 10.2478282,3.71201923 10.2478282,6.125 L10.2478282,9.55432692 L11.5535974,11.3194712 C11.6848474,11.4961538 11.7050397,11.7317308 11.6057609,11.9286058 C11.506482,12.1254808 11.3045589,12.25 11.0841262,12.25 Z M1.74013585,11.0838942 L9.92643393,11.0838942 L9.19446277,10.0944712 C9.12042431,9.99350962 9.0800397,9.87235577 9.0800397,9.74783654 L9.0800397,6.125 C9.0800397,4.35649038 7.62282816,2.91610577 5.83244354,2.91610577 C4.04205893,2.91610577 2.58653008,4.35649038 2.58653008,6.125 L2.58653008,9.74615385 C2.58653008,9.87067308 2.54614547,9.99182692 2.47210701,10.0927885 L1.74013585,11.0838942 Z M7.29302047,14 L4.37523201,14 C4.05383777,14 3.79133777,13.7391827 3.79133777,13.4161058 C3.79133777,13.0930288 4.05215508,12.8322115 4.37523201,12.8322115 L7.29133777,12.8322115 C7.61273201,12.8322115 7.87523201,13.0930288 7.87523201,13.4161058 C7.87523201,13.7391827 7.6144147,14 7.29302047,14 Z M6.12523201,1.16610577 L5.54133777,1.16610577 C5.21994354,1.16610577 4.95744354,0.905288462 4.95744354,0.582211538 C4.95744354,0.259134615 5.21994354,0 5.54302047,0 L6.1269147,0 C6.44830893,0 6.71080893,0.260817308 6.71080893,0.583894231 C6.71080893,0.906971154 6.44830893,1.16610577 6.12523201,1.16610577 L6.12523201,1.16610577 Z",
    id: "\\u5F62\\u72B6"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNoticeDefault);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/notice_default.71f45cc9ee84ea4c250058c4fee3ba86.svg";